var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fund-pills"},_vm._l((_vm.fundTags),function(characteristic,index){return _c('div',{key:index,staticClass:"fund-pill"},[_c('span',{staticClass:"fund-pill-text"},[_vm._v(" "+_vm._s(characteristic)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }